'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconShipmentBox = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M21.993 6.75a.5.5 0 0 0 .407-.791L18.8.919A1 1 0 0 0 17.985.5H12.75a.5.5 0 0 0-.5.5v5.25a.5.5 0 0 0 .5.5zM1 8.25a.5.5 0 0 0-.5.5V22.5a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1V8.75a.5.5 0 0 0-.5-.5zM12.5 18a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zM10.75 1a.5.5 0 0 0-.5-.5H6.015A1 1 0 0 0 5.2.919l-3.6 5.04a.5.5 0 0 0 .407.791h8.243a.5.5 0 0 0 .5-.5z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M1.5 24C.673 24 0 23.327 0 22.5V7.82a1.519 1.519 0 0 1 .279-.872L4.793.628A1.504 1.504 0 0 1 6.014 0h11.971c.485 0 .941.235 1.222.628l4.514 6.32A1.525 1.525 0 0 1 24 7.82V22.5c0 .827-.673 1.5-1.5 1.5h-21zM1 22.5a.5.5 0 0 0 .5.5h21a.5.5 0 0 0 .5-.5V8H1v14.5zM22.529 7l-4.135-5.791A.504.504 0 0 0 17.986 1H12.5v6h10.029zM11.5 7V1H6.014a.502.502 0 0 0-.407.209L1.471 7H11.5z' }),
    _react2.default.createElement('path', { d: 'M13.001 21a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-7zm0-1h7v-2h-7v2z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M3 24a2.252 2.252 0 0 1-2.25-2.25V8.25c0-.37.092-.737.267-1.062l2.388-5.831A2.267 2.267 0 0 1 5.471 0h13.055c.892 0 1.699.525 2.06 1.337l2.397 5.85c.174.326.267.693.267 1.063v13.5A2.252 2.252 0 0 1 21 24H3zM3 7.5a.75.75 0 0 0-.75.75v13.5c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75V8.25A.75.75 0 0 0 21 7.5H3zM20.875 6l-1.669-4.075a.74.74 0 0 0-.677-.425H12.75V6h8.125zM11.25 6V1.5H5.472a.75.75 0 0 0-.686.446L3.125 6h8.125z' }),
    _react2.default.createElement('path', { d: 'M14.25 19.5a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5h-4.5z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconShipmentBox.displayName = 'IconShipmentBox';
exports.default = IconShipmentBox;